<div class="_swatch b-a b-w-2 overflow-hidden ratio-1-1"
     [ngClass]="{'_selected' : selected}">

    @switch (getType()) {
    <!-- image -->
    @case ('image') {
    <img class="w-12 fill"
         [ratio]="1"
         [dfImage]="swatch"
         [alt]="altText" />
    }
    <!-- color -->
    @case ('background') {
    <span class="fill block"
          [style.background-color]="swatch"></span>
    }
    <!-- checkbox -->
    @default {
    <span class="fill block"></span>
    }
    }
    @if(displayZoom){

    <div class="p-a-1 pos-absolute top-1 right-1"
         (mouseenter)="toggleZoom($event, true)"
         (mouseleave)="toggleZoom($event, false)"
         style="background-color: rgba(255, 255, 255, 0.4); border-radius: 100%;">
        <i class="icon-zoom flex"
           style="font-size: 14px;"></i>
    </div>
    }
</div>
